import JSEncrypt from 'jsencrypt';
import { getPublicKey } from './client/graphql';

const rsaencrypt = (text, publicKey) => {
  try {
    const key = publicKey || getPublicKey();
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(key);

    const encrypted = encrypt.encrypt(text);

    if (encrypted === false) {
      throw new Error('Encryption failed - invalid public key or data');
    }

    return encrypted;
  } catch (error) {
    console.error('RSA encryption error:', error);
    throw new Error('Failed to encrypt data');
  }
};

export { rsaencrypt };
